import useProjects from './hooks/useProjects';
import SEO from 'components/SEO';
import Paper from 'components/Paper/Paper';
import ProjectCard from './components/ProjectCard/ProjectCard';
import Welcome from './components/Welcome';

const MyProject = () => {
  const { projects, isLoading, isError, refetch } = useProjects();
  const hasProjects = !isLoading && (projects?.length ?? 0) > 0;

  return (
    <>
      <SEO title="내 프로젝트" />
      <Paper title="내 프로젝트" isGrid={hasProjects} isLoading={isLoading} isError={isError} hasMaxWidth={false}>
        {hasProjects ? (
          projects?.map((project) => (
            <ProjectCard
              key={`${project.ownerEmail}/${project.projectName}`}
              project={project}
              projectsRefetch={refetch}
            />
          ))
        ) : (
          <Welcome />
        )}
      </Paper>
    </>
  );
};

export default MyProject;
